import { ModuleRegistry } from "seneca-common/features/module/registry";

import { generateInitialUserAnswer, markAnswer } from "./logic/answers";
import { generateContent } from "./logic/content";
import { initialiseState } from "./module-state";

export const MODULE_TYPE = "grid";
export type TYPE = "grid";

export const register = (moduleRegistry: ModuleRegistry) =>
  moduleRegistry
    .buildModule(MODULE_TYPE)
    .with.logic()
    .markAnswer(markAnswer)
    .generateContent(generateContent)
    .generateInitialUserAnswer(generateInitialUserAnswer)
    .generateInitialModuleState(initialiseState)
    .back.staticInformation()
    .displayName("Grid")
    .root.register();
